module.exports = __webpack_public_path__ + "static/media/me.ad7afd12.svg";